import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { clearAuthState } from 'utils/auth';

const userLogout = gql`
  mutation {
    logout
  }
`;

const withLogout = graphql(userLogout, {
  props: ({ ownProps: { redirectToRoot }, mutate }) => ({
    logout: (redirect = '/', redirectOptions) => {
      return mutate()
        .then(({ data }) => {
          clearAuthState(redirect, redirectOptions);

          return data;
        })
        .catch(err => {
          clearAuthState(redirect, redirectOptions);
        });
    }
  })
});

export default withLogout;
